import React from 'react';
import Modal from '../common/Modal';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from 'styled-components';

interface ProjectSubTypesInfoModalProps {
	open: boolean;
	onClose: () => void;
}

export default function ProjectSubTypesInfoModal({
	open,
	onClose,
}: ProjectSubTypesInfoModalProps) {
	return (
		<Modal
			open={open}
			handleClose={onClose}
			sx={{
				minWidth: '800px',
				maxWidth: '1000px',
				padding: 0,
				overflow: 'hidden',
			}}
		>
			<ModalContainer>
				{/* Header with close button */}
				<HeaderContainer>
					<Typography
						variant="h5"
						component="h2"
						sx={{ fontWeight: 500 }}
					>
						Project Sub Types
					</Typography>
					<IconButton
						onClick={onClose}
						sx={{
							color: 'text.secondary',
							'&:hover': {
								backgroundColor: 'action.hover',
							},
						}}
					>
						<CloseIcon />
					</IconButton>
				</HeaderContainer>

				{/* Content */}
				<ContentContainer>
					<Typography
						variant="body1"
						sx={{
							mb: 3,
							lineHeight: 1.6,
							color: 'text.primary',
						}}
					>
						Take control of your project setup! Project sub-types
						ensure that only the necessary templates are created for
						each project, leading to a more organized and
						clutter-free workspace.
					</Typography>

					{/* <ImagePlaceholder>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ fontStyle: 'italic' }}
						>
							[Project Sub-Types Interface Image Placeholder]
						</Typography>
					</ImagePlaceholder> */}
				</ContentContainer>
			</ModalContainer>
		</Modal>
	);
}

// Styled Components
const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	// height: 600px;
`;

const HeaderContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 24px 24px 0 24px;
	padding-bottom: 16px;
	margin-bottom: 24px;
`;

const ContentContainer = styled.div`
	padding: 0 24px 24px 24px;
	flex: 1;
	display: flex;
	flex-direction: column;
`;

const ImagePlaceholder = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 2px dashed ${({ theme }) => theme.palette.divider};
	border-radius: 8px;
	min-height: 300px;
	background-color: ${({ theme }) => theme.palette.background.default};
`;
